import { filledData } from "../../utils/response";
const axios = require("axios").default;

// A mock function to mimic making an async request for data
export function fetchCount() {
  return new Promise<TDataTable>((resolve) =>
    setTimeout(
      () =>
        resolve(
          // axios.get('http://homestead.test/api/developers').then((response: any) => response.data )
          filledData
        ),
      1000
    )
  );
}
